import { CLEAR_SEARCHTEXT_AND_SEARCHLIST } from "./actionTypes";

export default () => ({
  type: CLEAR_SEARCHTEXT_AND_SEARCHLIST,
  payload: {}
});